import React from 'react';
import styles from './StoreOrdering.module.css';

/**
 * Skeleton loading components for merchant orders
 */

// Base skeleton box with shimmer
export const SkeletonBox = ({ width, height, borderRadius = '8px', style = {} }) => (
  <div
    className={styles['skeleton-box']}
    style={{
      width,
      height,
      borderRadius,
      ...style,
    }}
  />
);

// Skeleton for text lines
export const SkeletonText = ({ width = '100%', height = '1rem' }) => (
  <SkeletonBox width={width} height={height} borderRadius="4px" />
);

// Skeleton for the search bar
export const SkeletonSearchBar = () => (
  <div className={styles['search-bar-wrapper']}>
    <div className={styles['search-input-container']}>
      <SkeletonBox width="100%" height="52px" borderRadius="12px" />
    </div>
    <SkeletonBox width="52px" height="52px" borderRadius="12px" />
  </div>
);

// Skeleton for a single product list item
export const SkeletonProductItem = () => (
  <div className={`${styles['product-list-item']} ${styles['skeleton-item']}`}>
    <div className={styles['product-info']}>
      <SkeletonText width="140px" height="1.1rem" />
      <SkeletonText width="100px" height="0.85rem" />
    </div>
    <SkeletonText width="40px" height="0.75rem" />
  </div>
);

// Skeleton for the product list
export const SkeletonProductList = ({ count = 6 }) => (
  <div className={styles['product-list-container']}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonProductItem key={i} />
    ))}
  </div>
);

// Skeleton for a cart item
export const SkeletonCartItem = () => (
  <div className={`${styles['cart-item']} ${styles['skeleton-item']}`}>
    <div className={styles['item-info']}>
      <SkeletonText width="120px" height="1rem" />
      <SkeletonText width="80px" height="0.85rem" />
    </div>
    <SkeletonText width="50px" height="1rem" />
  </div>
);

// Skeleton for the order cart
export const SkeletonCart = () => (
  <div className={styles['order-cart']}>
    <div className={styles['order-cart-header']}>
      <SkeletonText width="100px" height="1.1rem" />
      <SkeletonBox width="40px" height="24px" borderRadius="999px" />
    </div>
    <div className={styles['order-cart-items']}>
      <SkeletonCartItem />
      <SkeletonCartItem />
    </div>
    <div className={styles['order-cart-footer']}>
      <div className={styles['cart-total']}>
        <SkeletonText width="80px" height="1rem" />
        <SkeletonText width="70px" height="1.5rem" />
      </div>
      <SkeletonBox width="100%" height="56px" borderRadius="14px" />
    </div>
  </div>
);

// Skeleton for the "Create Order" tab layout
export const SkeletonNewOrderLayout = () => (
  <div className={styles['new-order-layout']}>
    <div className={styles['products-panel']}>
      <SkeletonSearchBar />
      <SkeletonProductList count={6} />
    </div>
    <div className={styles['cart-panel']}>
      <SkeletonCart />
    </div>
  </div>
);

// Skeleton for an order card
export const SkeletonOrderCard = () => (
  <div className={styles['order-card']}>
    <div className={styles['order-card-header']}>
      <div className={styles['order-card-info']}>
        <SkeletonText width="150px" height="1rem" />
        <SkeletonText width="100px" height="0.85rem" />
      </div>
      <SkeletonBox width="70px" height="24px" borderRadius="999px" />
    </div>
  </div>
);

// Skeleton for the orders list
export const SkeletonOrdersList = ({ count = 4 }) => (
  <div className={styles['my-orders-list']}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonOrderCard key={i} />
    ))}
  </div>
);

// Skeleton for the page-level loading (used in MerchantOrders.js)
export const SkeletonPageLoading = () => (
  <div className={styles['store-ordering-container']}>
    <section className={styles['new-order-section']}>
      <SkeletonNewOrderLayout />
    </section>
  </div>
);
